import styled from '@emotion/styled'

import ColumnTrack from '@segment/matcha/components/ColumnTrack'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'
import SectionBase, * as Section from '@segment/matcha/recipes/Section'

import getAbsoluteUrl from '@segment/utils/getAbsoluteUrl'

import type { PageConfig } from '@segment/contexts/page'
import { usePageConfig } from '@segment/contexts/page'

import SuperchargeImage from './SuperchargeImage'

const copyBase = (pageConfig: PageConfig) => {
  return {
    title: `Supercharge your audience creation with CustomerAI`,
    description: `Our predictive and generative AI accelerates and enriches the creation of audience segmentations at a lightning-fast pace. Then Segment keeps those audiences up-to-date automatically, so you can activate them everywhere such as messaging channels or major ad platforms.`,
    list: [
      {
        title: `Effortlessly discover and launch the best prediction-powered audience for every campaign`,
        description: (
          <>
            Predictive Audiences "ready to buy," "dormant," "potential VIPs," and more — built on the out-of-the-box
            machine learning models within{` `}
            <a href={getAbsoluteUrl(`/solutions/ai/customerai-predictions/`, pageConfig)}>CustomerAI Predictions</a> can
            spark innovative campaign ideas and enable you to swiftly generate AI-powered audiences with just a few
            clicks.
          </>
        ),
      },
      {
        title: `Create targeted audiences in minutes with CustomerAI Generative Audiences`,
        description: `Save time by creating highly targeted audiences within minutes using a simple natural language text prompt to speed time launch for campaigns and achieve your marketing goals.`,
      },
    ],
  }
}

const Supercharge = () => {
  const pageConfig = usePageConfig()
  const copy = copyBase(pageConfig)
  return (
    <SectionBase sticky={true} variant="2Col">
      <Section.Contents>
        <Section.Sticky>
          <SuperchargeImage />
        </Section.Sticky>
      </Section.Contents>
      <Section.Copy>
        <CopyTextBase>
          <CopyText.Heading tag="h2" variant="h2">
            {copy.title}
          </CopyText.Heading>
          <CopyText.Description tag="p" variant="pLarge">
            {copy.description}
          </CopyText.Description>
          <StyledColumnTrack>
            {copy.list.map(({ title, description }, key) => (
              <CopyTextBase key={key}>
                <CopyText.Heading tag="h3" variant="h5">
                  {title}
                </CopyText.Heading>
                <CopyText.Description tag="p" variant="pMedium">
                  {description}
                </CopyText.Description>
              </CopyTextBase>
            ))}
          </StyledColumnTrack>
        </CopyTextBase>
      </Section.Copy>
    </SectionBase>
  )
}

const StyledColumnTrack = styled(ColumnTrack)`
  margin-top: 48px;
`

export default Supercharge
